// One of the demo's five sales regions of the United States, by the states in it: the Map demo draws
// them and works out their figures, and the Kanban board demos offer a view of each. The demo's sample
// companies are all in the United States, each with its state in its address.

export interface DemoRegion {
  /** The region in the demos' strings: `region-{key}` on the map, `view-{key}` on a board. */
  key: string;
  /** The states in the region, as the addresses name them. */
  states: readonly string[];
}

export const WEST: DemoRegion = {
  key: 'west',
  states: [
    'Alaska', 'California', 'Colorado', 'Hawaii', 'Idaho', 'Montana', 'Nevada', 'Oregon', 'Utah', 'Washington',
    'Wyoming',
  ],
};

export const SOUTHWEST: DemoRegion = { key: 'southwest', states: ['Arizona', 'New Mexico', 'Oklahoma', 'Texas'] };

export const MIDWEST: DemoRegion = {
  key: 'midwest',
  states: [
    'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Michigan', 'Minnesota', 'Missouri', 'Nebraska', 'North Dakota',
    'Ohio', 'South Dakota', 'Wisconsin',
  ],
};

export const SOUTHEAST: DemoRegion = {
  key: 'southeast',
  states: [
    'Alabama', 'Arkansas', 'Florida', 'Georgia', 'Kentucky', 'Louisiana', 'Mississippi', 'North Carolina',
    'South Carolina', 'Tennessee', 'Virginia', 'West Virginia',
  ],
};

export const NORTHEAST: DemoRegion = {
  key: 'northeast',
  states: [
    'Connecticut', 'Delaware', 'Maine', 'Maryland', 'Massachusetts', 'New Hampshire', 'New Jersey', 'New York',
    'Pennsylvania', 'Rhode Island', 'Vermont',
  ],
};

/**
 * A FetchXML condition keeping the rows whose address is in one of the region's states: it goes in a
 * filter of the entity the address is on.
 */
export function statesCondition(region: DemoRegion): string {
  const values = region.states.map((state) => `<value>${state}</value>`).join('');
  return `<condition attribute="address1_stateorprovince" operator="in">${values}</condition>`;
}

/**
 * A FetchXML link to the company a record is about, through `column`, keeping the records of companies
 * in the region: it goes inside the record's entity. A record about no company, as a visitor's own
 * usually is, is left out.
 */
export function companiesIn(region: DemoRegion, column: string): string {
  return `<link-entity name="account" from="accountid" to="${column}" link-type="inner"><filter>${statesCondition(region)}</filter></link-entity>`;
}
